   // Coveo Result List click and render CRL
   analytics.eventConfig.push({
    "target": ".CoveoResultList",
    "codeId": "crl",
    "events": [
        {
            "eventTarget": ".CoveoResultLink",
            "eventType": "click",
            "tags": {
                "componentId": "crl",
                "componentName": "coveo results list",
                "destinationUrl": "",
                "elementText": "",
                "elementType": "search results list",
                "event": "onsite search",
                "eventType": "search results click through",
                "resultType": "",
                "searchFacets": "",
                "searchResults": "",
                "searchTerm": "",
                "searchType": "",
                "showMore": "",
                "doc_path": "",
                "document_host": "",
                "event1": "",
                "page_type": "",
                "page_bu": "",
                "page_language": "",
                "page_title": "",
                "pardot_cookie_id": "",
                "site_search_results_count": 0,
                "sitecore_contact_id": "",
                "eventAction": "",
                "eventCategory": "",
                "eventLabel": "",
                "environment": "",
            }
        },
        {
            "eventTarget": ".coveo-result-list-container",
            "eventType": "SearchResultsRendering",
            "tags": {
                "componentId": "crl",
                "componentName": "coveo results list",
                "elementType": "search results list",
                "event": "onsite search",
                "eventType": "search results return",
                "searchFacets": "",
                "searchResults": "",
                "searchTerm": "",
                "searchType": "",
                "showMore": "",
                "doc_path": "",
                "document_host": "",
                "event1": "",
                "page_type": "",
                "page_bu": "",
                "page_language": "",
                "page_title": "",
                "pardot_cookie_id": "",
                "site_search_results_count": 0,
                "sitecore_contact_id": "",
                "eventAction": "",
                "eventCategory": "",
                "eventLabel": "",
                "environment": "",

            }
        }
    ]
},
{
    "target": ".CoveoResultList",
    "codeId": "crl",
    "events": [
        {
            "eventTarget": ".CoveoResult a:not(.CoveoResultLink)",
            "eventType": "click",
            "tags": {
                "componentId": "crl",
                "componentName": "coveo results list",
                "destinationUrl": "",
                "elementText": "",
                "elementType": "search results list",
                "event": "onsite search",
                "eventType": "search results click through",
                "resultType": "",
                "searchFacets": "",
                "searchResults": "",
                "searchTerm": "",
                "searchType": "",
                "showMore": "",
                'event1': '',
                'eventCategory': '',
                'eventAction': 'Document Downloaded',
                'eventLabel': "",
                "environment": "",
                'document_title': "",
                'document_type': "",
                'page_type': "",
                'page_title': "",
                'page_bu': "",
                'page_language': "",
                'sitecore_contact_id': "",
                'pardot_cookie_id': ""

            }
        }
    ]
},     
{// Coveo Search Box CSB
    "target": ".CoveoSearchInterface",
    "events": [
        {
            "eventTarget": ".recent-searches a",
            "eventType": "click",
            "tags": {
                "event": "onsite search",
                "componentName": "coveo search box",
                "componentId": "csb",
                "eventType": "search submit",
                "elementType": "recent search link",
                "parentName": "",
                "searchTerm": "",
                "searchType": ""
            }
        },
        {
            "eventTarget": ".magic-box-suggestions",
            "eventType": "SearchBoxSuggestion",
            "tags": {
                "componentId": "csb",
                "componentName": "coveo search box",
                "event": "onsite search",
                "eventType": "search submit",
                "elementType": "auto-suggestion",
                "parentName": "",
                "searchTerm": "",
                "searchType": ""
            }
        },
        {
            "eventTarget": ".CoveoSearchbox",
            "eventType": "SearchBoxSearch",
            "tags": {
                "componentId": "csb",
                "componentName": "coveo search box",
                "event": "onsite search",
                "eventType": "search submit",
                "elementType": "search box",
                "parentName": "",
                "searchTerm": "",
                "searchType": ""
            }
        },
        {
            "eventTarget": "a.CoveoSearchButton",
            "eventType": "click",
            "tags": {
                "componentId": "csb",
                "componentName": "coveo search box",
                "event": "onsite search",
                "eventType": "search submit",
                "elementType": "search box",
                "parentName": "",
                "searchTerm": "",
                "searchType": ""
            }
        }
    ]
}, 
{ // Coveo Facet CF
    "target": ".component.coveo-facet",
    "codeId": "cf",
    "events": [
        {
            "eventTarget": ".CoveoFacet",
            "eventType": "FacetChanged",
            "tags": {
                "event": "onsite search",
                "eventType": "",
                "componentName": "coveo facet",
                "componentId": "cf",
                "elementType": "search filter selection box",
                "elementText": "",
                "refinementCategory": "",
                "searchTerm": "",
                "searchType": ""
            }
        }
    ]
},
{
    "target": ".facet-modal",
    "codeId": "cf",
    "events": [
        {
            "eventTarget": "label",
            "eventType": "click",
            "tags": {
                "componentId": "cf",
                "componentName": "coveo facet",
                "elementText": "",
                "elementType": [
                    {
                        "rule": "$(context).parents('.modal').length > 0 || $(context).parents('.modal').attr('id') === 'location-modal'",
                        "value": "location link"
                    },
                    {
                        "rule": "true",
                        "value": "product family link"
                    }
                ],
                "event": "onsite search",
                "eventType": [
                    {
                        "rule": "$(context).parents('.modal').length > 0 || $(context).parents('.modal').attr('id') === 'location-modal'",
                        "value": "location selection click"
                    },
                    {
                        "rule": "true",
                        "value": "product family selection click"
                    }
                ],
                "searchTerm": "",
                "searchType": ""
            }
        }
    ]
}, {
    "target": ".coveo-facet",
    "codeId": "cf",
    "events": [
        {
            "eventTarget": ".showLessText",
            "eventType": "click",
            "tags": {
                "componentId": "cf",
                "componentName": "coveo facet",
                "elementText": "show less",
                "elementType": "show less button",
                "event": "onsite search",
                "eventType": "show less facet click",
                "searchTerm": "",
                "searchType": "",
            }
        },
    ]
},
{
    "target": ".coveo-facet",
    "codeId": "cf",
    "events": [
        {
            "eventTarget": ".showMoreText",
            "eventType": "click",
            "tags": {
                "componentId": "cf",
                "componentName": "coveo facet",
                "elementText": "show more",
                "elementType": "show more button",
                "event": "onsite search",
                "eventType": "show more facet click",
                "searchTerm": "",
                "searchType": "",
            }
        },
    ]
}, 
{   // Coveo Show More CRL
    "target": ".CoveoSearchInterface",
    "codeId": "crl",
    "events": [
        {
            "eventTarget": ".showMoreResults a",
            "eventType": "click",
            "tags": {
                "componentId": "crl",
                "componentName": "coveo results list",
                "elementText": "",
                "elementType": "load more button",
                "event": "onsite search",
                "eventType": "load more results click",
                "searchTerm": "",
                "searchType": ""
            }
        },
        {
            "eventTarget": ".coveo-pager-next span.coveo-pager-next-icon",
            "eventType": "click",
            "tags": {
                "componentId": "crl",
                "componentName": "coveo results list",
                "elementText": "",
                "elementType": "load next button",
                "event": "onsite search",
                "eventType": "load next page results click",
                "searchTerm": "",
                "searchType": ""
            }
        },
        {
            "eventTarget": ".coveo-pager-previous span.coveo-pager-previous-icon",
            "eventType": "click",
            "tags": {
                "componentId": "crl",
                "componentName": "coveo results list",
                "elementText": "",
                "elementType": "load previous button",
                "event": "onsite search",
                "eventType": "load previous page results click",
                "searchTerm": "",
                "searchType": ""
            }
        },
        {
            "eventTarget": "a.seeallList",
            "eventType": "click",
            "tags": {
                "componentId": "crl",
                "componentName": "coveo results list",
                "elementText": "",
                "elementType": "load all button",
                "event": "onsite search",
                "eventType": "load all results click",
                "searchTerm": "",
                "searchType": ""
            }
        },
        {
            "eventTarget": "a.seeLessList",
            "eventType": "click",
            "tags": {
                "componentId": "crl",
                "componentName": "coveo results list",
                "elementText": "",
                "elementType": "load less button",
                "event": "onsite search",
                "eventType": "load less results click",
                "searchTerm": "",
                "searchType": ""
            }
        }
    ]
});